/* eslint-disable react/no-unstable-nested-components */
import RefreshButton from "components/financials/modern/RefreshButton";
import TextAlignmentRadioGroup from "components/financials/modern/TextAlignmentRadioGroup";
import ToggleSortingButton from "components/financials/modern/ToggleSortingButton";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/Popover";
import classNames from "components/ui/classNames";
import useTheme from "components/ui/useTheme";
import { SettingsIcon } from "lucide-react";

interface SettingsPopoverProps {
  loading: boolean;
  textAlignment: "LEFT" | "CENTER" | "RIGHT";
  sortDirection: "ASC" | "DESC";
  onChangeTextAlignment: (value: "LEFT" | "CENTER" | "RIGHT") => void;
  onToggleSorting: () => void;
  onClickRefetch?: () => void;
  className?: string;
}
export default function SettingsPopover({
  loading,
  sortDirection,
  textAlignment,
  onToggleSorting,
  onChangeTextAlignment,
  onClickRefetch,
  className,
}: SettingsPopoverProps) {
  const theme = useTheme();

  return (
    <Popover>
      <PopoverTrigger
        className={classNames(
          "rounded-xl bg-slate-50/60 p-2",
          "border border-slate-200 text-sm font-medium tracking-wide text-slate-600",
          "dark:border-slate-950 dark:bg-slate-700 dark:text-slate-300",
          "focus-visible:outline-none",
          "focus-visible:ring-1 focus-visible:ring-offset-1",
          "focus-visible:ring-gray-100 focus-visible:ring-offset-gray-300",
          "focus-visible:border-transparent focus-visible:bg-gray-50 focus-visible:text-gray-600",
          "dark:focus-visible:ring-slate-950 dark:focus-visible:ring-offset-transparent",
          "hover:bg-slate-100 hover:dark:bg-slate-600",
          className,
        )}
      >
        <SettingsIcon />
      </PopoverTrigger>

      <PopoverContent
        className={classNames(
          "flex items-center space-x-2 rounded-xl border border-slate-300 p-2",
          "shadow-md shadow-slate-900/10",
          {
            "border-slate-900/80 bg-slate-800 shadow-neutral-950/40": theme === "dark",
            dark: theme === "dark",
          },
        )}
        align="center"
        onOpenAutoFocus={(event) => {
          // See: https://github.com/radix-ui/primitives/discussions/935
          event.preventDefault();
        }}
      >
        <ToggleSortingButton sortDirection={sortDirection} onClick={() => onToggleSorting()} />

        <TextAlignmentRadioGroup value={textAlignment} onChange={onChangeTextAlignment} />

        {onClickRefetch && <RefreshButton loading={loading} onClick={onClickRefetch} />}
      </PopoverContent>
    </Popover>
  );
}
